import React from "react";
import searchIcon from "../../../assets/test-new/searchIcon.svg";
import "./SearchBar.css";

const SearchBar = ({ searchInput, handleSearchChange, handleKeyDown }) => {
  const handleFocus = () => {
    if (searchInput.length > 0) {
      handleSearchChange({ target: { value: searchInput } });
    }
  };

  return (
    <div className="search-bar-wrapper">
      <input
        type="text"
        className="search-bar-input"
        placeholder="Search Questions (such as Java, C++, Linux...)"
        value={searchInput}
        onChange={handleSearchChange}
        onFocus={handleFocus}
        onKeyDown={handleKeyDown}
      />
      <div className="search-bar-icon-wrapper">
        <img className="search-bar-icon" src={searchIcon} alt="Search" />
      </div>
    </div>
  );
};


export default SearchBar;
